import { minLength, maxLength, stringPattern, tagMaxLength, tagMinLength } from '../../utils/form-validations';

export const digitaltwinDefaultFields = {
  dt_name: '', 
  onto_manage_id: null,
};

export const digitalTwinUISchema = [
  { id: 1, label: 'Country', name: 'onto_manage_id', type: 'select', required: true },
  { id: 2, label: 'Name of Digital Twin', name: 'dt_name', type: 'input', required: true },
];

export const digitalTwinSchema = {
  type: 'object',
  properties: {
    onto_manage_id: { type: 'number', minLength: 1, maxLength },
    dt_name: { type: 'string', minLength, maxLength, pattern: stringPattern },
  },
  required: ['onto_manage_id', 'dt_name'],
  additionalProperties: true,
};


